// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__GGjnL","card":"page_card__S5rBo","cardContainer":"page_cardContainer__dWzW3","typeSelectorContainer":"page_typeSelectorContainer__laOEp"};